// eslint-disable-next-line no-unused-vars
import React, { memo, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { ToastNotification } from '@carbon/react';
import styled from '@emotion/styled';
import { useContextSelector } from 'use-context-selector';
import { Global, css, useTheme } from '@emotion/react';

import { ToastNotificationsContext } from 'Contexts/ToastNotificationsContext';

const StyledToastNotification = styled(ToastNotification)`
  border-radius: 6px;
  background-color: ${ props => props.theme.colors.white } !important;
  color: ${ props => props.theme.colors.darkGray } !important;
  border: 0 !important;
  box-shadow: 0 0 40px #00000029 !important;
`;

const ToastNotificationsComponent = memo(() => {
  const notifications = useContextSelector(ToastNotificationsContext, data => data.data) || [];
  const theme = useTheme();

  const elements = useMemo(() => notifications.map(notification => (
    <StyledToastNotification
      theme={ theme }
      key={ notification.id }
      kind={ notification.type || 'info' }
      lowContrast
      title={ notification.title }
      subtitle={ notification.message || notification.subtitle }
      timeout={ Math.max(notification.timeout || 3000, 1000) }
    />
  )), [notifications]);

  const component = (
    <>
      <Global
        styles={
          css`
            .ToastNotifications {
              width: 100%;
              height: 0;
              position: sticky;
              right: 0;
              top: 25px;
              display: flex;
              flex-direction: column;
              align-items: flex-end;
              z-index: 10001;
            }
          `
        }
      />
      { elements }
    </>
  );

  if (typeof document !== 'undefined') {
    const container = document.getElementById('root-toasts');
    if (container) {
      return createPortal(component, container);
    }
  }

  return component;
});

ToastNotificationsComponent.displayName = 'ToastNotificationsComponent';

export default ToastNotificationsComponent;
